import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DatabaseService } from 'src/app/servicios/database/database.service';
import { FsessionService } from 'src/app/servicios/session/fsession.service';
import { MunicipalityTokenService } from 'src/app/servicios/municipality-token/municipality-token.service';
import { DefaultRouteNavigationService } from './default-route-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class InitialDefaultRouteService {
  private readonly db = inject(DatabaseService);
  private readonly defaultRouteNav = inject(DefaultRouteNavigationService);
  private readonly municipalityTokenService = inject(MunicipalityTokenService);
  private readonly fse = inject(FsessionService);
  private readonly router = inject(Router);

  async tryNavigateToDefaultRoute(): Promise<boolean> {
    try {
      const data = await firstValueFrom(this.db.obtenerRutaPredeterminadaInicio());
      if (!data?.defaultRoute) {
        return false;
      }

      const permissions = (this.municipalityTokenService.getMunicipalityPermissions() || '')
        .split(',')
        .map((permission) => permission.trim())
        .filter(Boolean);

      if (!permissions.includes(String(data.defaultRoute))) {
        return false;
      }

      const resolved = await this.defaultRouteNav.getResolvedRoute(data.defaultRoute);
      if (!resolved) {
        return false;
      }

      const modules = (this.municipalityTokenService.getModules() || '')
        .split(',')
        .map((moduleId) => moduleId.trim())
        .filter(Boolean);

      if (!modules.includes(String(resolved.moduleType))) {
        return false;
      }

      this.fse.agregarActualizar('routeInit', resolved.fullPath);
      await this.router.navigate(resolved.fullPath.split('/').filter(Boolean));
      return true;
    } catch {
      return false;
    }
  }
}
